import { render } from "./OutOfOfficeBanner.vue?vue&type=template&id=7218cbfe"
import script from "./OutOfOfficeBanner.vue?vue&type=script&lang=js"
export * from "./OutOfOfficeBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__